module.exports = "<ul>\n<li>Appbooster, Backend developer, 2020-</li>\n<li>MDL Talent Hub, Backend developer, 2017-2020</li>\n<li>DataArt, Developer, 2015–2016</li>\n<li>SPBTV, Developer, 2012–2013</li>\n<li>First Line Software, Developer, 2012</li>\n<li>Transas, C++ developer, 2010</li>\n</ul>\n";


//////////////////
// WEBPACK FOOTER
// ./src/articles/experience.md
// module id = dCxT
// module chunks = 1